import {all, call, put, takeLatest} from 'redux-saga/effects'
import {generalError} from '../actions'
import types from '../actions/types'
import {sessionLoginAttempt, sessionLoginFailure} from 'actions/auth'
import {loadConfigFailure, loadConfigSuccess, loadServiceHealthSuccess} from 'actions/config'
import {getFailureCode, getFailureReason} from 'helpers/api'
import {getConsolidatedServiceHealth, isDev} from "helpers/system"

export default (api) => {

  function* loadConfig() {
    try {
      const result = yield call(api.config.load)
      if (result.ok) {
        yield put(loadConfigSuccess(result.data))
        yield put(sessionLoginAttempt())

        window.systemName = result.data?.data?.systemName
        yield call(loadServiceHealth)
      } else {
        yield put(loadConfigFailure(getFailureReason(result), getFailureCode(result)))
        yield put(sessionLoginFailure())
        yield put(generalError('Sorry, there was a problem connecting to Clarity Go. Please refresh the page to try again.'))
      }
    } catch (e) {
      yield put(generalError(e.message))
      console.error(e)
    }
  }

  function* loadServiceHealth() {
    try {
      if (!isDev())
        return

      const result = yield call(api.config.serviceHealth)
      if (result.ok) {
        yield put(loadServiceHealthSuccess(getConsolidatedServiceHealth(result.data)))
      } else {
        yield put(generalError('Service health could not be loaded'))
        console.error(result)
      }
    } catch (e) {
      yield put(generalError(e.message))
      console.error(e)
    }
  }

  function* watcher() {
    yield all([
      takeLatest(types.CONFIG_LOAD_ATTEMPT, loadConfig),
    ])
  }

  return {
    watcher,
  }
}
